import { C, M, T, getEmpresa } from './theme.js';
import { cabecera } from './v2/base.js';

// "LISTA DE PRECIOS" → "Lista de precios"; lo que ya viene escrito normal queda igual
const titulo = (t) => {
    const s = String(t || '').trim();
    return s && s === s.toUpperCase() ? s.charAt(0) + s.slice(1).toLowerCase() : s;
};
export const ctxDe = ({ tipoLabel, fecha = null, tecnico = null, nroDoc = null, extra = null }) => ({
    titulo: titulo(tipoLabel),
    sub: [nroDoc ? (/^\D/.test(String(nroDoc)) && !/^[A-Z]{2}-/.test(String(nroDoc)) ? nroDoc : `N° ${nroDoc}`) : null, fecha, extra,
        tecnico ? `Técnico: ${tecnico}` : null].filter(Boolean).join('  ·  '),
});

// ── HEADER PRINCIPAL ──────────────────────────────────────────────────────────
// Logo + empresa izquierda, info boxes + badge derecha, divisor rojo, título
export function dibujarHeader(doc, { tipoLabel, fecha, tecnico = null, nroDoc = null }) {
    // 18-oct-2026: todos los PDF con la misma cabecera que el diseño nuevo (logo con peso + título)
    return cabecera(doc, ctxDe({ tipoLabel, fecha, tecnico, nroDoc }));
}

// ── HEADER COMPACTO (todas las páginas) ──────────────────────────────────────
export function dibujarHeaderCompacto(doc, { tipoLabel, fecha, tecnico = null, nroDoc = null }) {
    return cabecera(doc, ctxDe({ tipoLabel, fecha, tecnico, nroDoc }));
}

// ── HEADER MINI (página de fotos — solo título + nroDoc + línea) ──────────────
export function dibujarHeaderMini(doc, { tipoLabel, nroDoc = null }) {
    return cabecera(doc, ctxDe({ tipoLabel, nroDoc }), { mini: true });
}

// ── FOOTER ────────────────────────────────────────────────────────────────────
export function dibujarFooter(doc, { pagina = null, totalPaginas = null, textoCentral = null, conEstrellas = false }) {
    const pageW   = doc.internal.pageSize.getWidth();
    const pageH   = doc.internal.pageSize.getHeight();
    const empresa = getEmpresa();

    // Línea roja sutil (consistente con header)
    doc.setDrawColor(...C.red);
    doc.setLineWidth(0.5);
    doc.line(M, pageH - 15, pageW - M, pageH - 15);

    // Fila 1: mensaje o texto central
    if (textoCentral) {
        doc.setFontSize(T.label);
        doc.setFont(undefined, 'italic');
        doc.setTextColor(...C.grayText);
        doc.text(textoCentral, pageW / 2, pageH - 10, { align: 'center' });
    } else {
        doc.setFontSize(T.xs);
        doc.setFont(undefined, 'bold');
        doc.setTextColor(...C.navy);
        doc.text('Gracias por confiar en nosotros', pageW / 2, pageH - 10, { align: 'center' });
    }

    // Fila 2: web, mail, redes y WhatsApp de la empresa, solo texto (18-oct-2026)
    const contacto = [
        empresa.web, empresa.email,
        empresa.instagram ? `IG ${empresa.instagram}` : null,
        empresa.tiktok ? `TikTok ${empresa.tiktok}` : null,
        empresa.whatsapp ? `WhatsApp ${empresa.whatsapp}` : null,
    ].filter(Boolean).join('   ·   ');
    let fs = T.label;
    doc.setFont(undefined, 'normal');
    doc.setTextColor(...C.grayText);
    doc.setFontSize(fs);
    // Deja libre la esquina derecha para la paginación
    while (doc.getTextWidth(contacto) > pageW - M * 2 - 24 && fs > 4.5) { fs -= 0.25; doc.setFontSize(fs); }
    doc.text(contacto, pageW / 2, pageH - 5, { align: 'center' });

    // Paginación derecha
    if (pagina && totalPaginas) {
        doc.setFontSize(T.xxs);
        doc.setFont(undefined, 'bold');
        doc.setTextColor(...C.navy);
        doc.text(`${pagina} / ${totalPaginas}`, pageW - M, pageH - 5, { align: 'right' });
    }
}
